export const API_BASE_URL = (process.env.NEXT_PUBLIC_API_BASE_URL || 'http://51.68.54.83:7002/api').replace(/\/$/, '');